import { render, staticRenderFns } from "./GeneralNotification.vue?vue&type=template&id=7e89e4e6&scoped=true&"
import script from "./GeneralNotification.vue?vue&type=script&lang=js&"
export * from "./GeneralNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e89e4e6",
  null
  
)

export default component.exports